<template>
    <div class="icon-process-wrapper">
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-fire"></i>
                </div>
                <h5 class="icon-process-single__title">Protect Data</h5>
                <div class="icon-process-single__text">
                    Keeping all medical records and patient bills in Managemed will safeguard them against potential natural disasters or other existential dangers in the physical world.
                </div>
            </div>
        </div>
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-users"></i>
                </div>
                <h5 class="icon-process-single__title">Manage</h5>
                <div class="icon-process-single__text">
                    Organise medical practices in an integrable manner to keep patient records, bills, and organisation inventories aligned with treatments.
                </div>
            </div>
        </div>
        <div class="icon-process-single wow move-up">
            <div class="icon-process-single__line">
                <div class="dot dot-1"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-5"></div>
                <div class="dot dot-4"></div>
                <div class="dot dot-3"></div>
                <div class="dot dot-2"></div>
                <div class="dot dot-1"></div>
            </div>
            <div class="icon-process-single__content-wrap">
                <div class="icon-process-single__media">
                    <i class="fa fa-chart-line"></i>
                </div>
                <h5 class="icon-process-single__title">Be More Efficient</h5>
                <div class="icon-process-single__text">
                    Allow for scale when treating patients and leading organisations through data-based decision making.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Gradation',
    };
</script>
